export const COURSE_DETAILS_MAP: Record<string, any> = {
    'oil-painting': {
        title: "Oil Painting",
        synopsis: "",
        levels: {
            basic: {
                price: "$20",
                syllabus: [
                    {
                        title: "In this course, students will get an overview of the following",
                        subItems: ["How to mix color", "How to prepare a canvas", "How to setup a pallette", "How to use a pallete knife"]
                    },
                    {
                        title: "Learn about the use of different types of brushes",
                        subItems: ["How to choose brushes", "How to clean and store brushes"]
                    },
                    "Learn about blending colors",
                    "How to layer wet and dry paint",
                    "How to glaze",
                    "How to consider color temperature, value proportion and shading"
                ],
                color: "#2C3333",
                image: "/assets/imgs/gallery/oil_color.jpeg"
            },
            intermediate: {
                price: "$23",
                synopsis: "Brushwork & Techniques – Blending, glazing, impasto, and layering.",
                syllabus: [
                    {
                        title: "Develop skills and techniques of mixing colors",
                        subItems: ["Understand primary, secondary & tertiary colors", "Learn blending and shading techniques", "Laying paint: Fat over lean technique", "Glazing: Learn how to use glaing to create effects", "Toning: Learn how to use toning to create effects"]
                    },
                    "Learn to complete a project from start to finish",
                    "Learn how to compose a painting - Learn how to compose a painting from scratch"
                ],
                color: "#1A3C40",
                image: "/assets/imgs/gallery/oil_painting_large.jpg"
            },
            advanced: {
                price: "$17",
                synopsis: "Learning how to mix oil painting",
                syllabus: [
                    {
                        title: "In this course, students will focus on exploring complex color theory, mastering advanced techniques, developing strong personal artistic style",
                        subItems: ["Advanced color mixing technique", "Complex tones", "Using color theory to create mood and depth", "With glazing, add transparency and depth to colors"]
                    },
                    {
                        title: "Advanced usage of brushes",
                        subItems: ["Mastering various brush strokes for texture and effect"]
                    },
                    "Applying thick layer of paint to create dimension",
                    "Wet-on-wet blending for seamless color transition",
                    "Using perspective to create realistic paint"
                ],
                color: "#191919",
                image: "/assets/imgs/gallery/oil_painting_advanced.jpg"
            }
        }
    },
    'water-color': {
        title: "Water-color",
        synopsis: "",
        levels: {
            basic: {
                price: "$19",
                synopsis: "Foundational techniques for beginners: color mixing and brush control.",
                syllabus: ["Wet and wet and wet and dry technique",
                    "Splattering paint technique",
                    "Dabbing technique",
                    "Learn how to mix paint to achieve the right tones and when to use more opaque or watery color",
                    "Learn how to mix diffrent shades"],
                color: "#2C3333",
                image: "/assets/imgs/gallery/w-image1.jpg"
            },
            intermediate: {
                price: "$22",
                synopsis: "In an intermediate watercolor class, students will typically learn advanced techniques to refine the watercolor skills.",
                syllabus: ["Focusing on advanced composition strategies, utilizing masking fluids, exploring different textures",
                    "Focusing on specific subject matter like landscapes or portraits with greater depth and atmosphere with using light and shadow.",
                    "Developing personal artistic style through critiques and experimentation and group discussion.",
                    "Advanced color mixing techniques, exploring color harmonies, and using color to create depth and atmosphere",
                    "Practicing precise brush strokes to render fine details and textures.",
                    "Creating realistic depth and volume through use of light and shadow"],
                color: "#1A3C40",
                image: "/assets/imgs/gallery/w-image2.jpg"
            },
            advanced: {
                price: "$25",
                synopsis: "Advanced watercolor classes provide the opportunity to push your creative boundaries, try new things, and perfect your approach to painting with watercolors",
                syllabus: ["How to create advanced shading and detail Painting techniques.",
                    "How to build up transparent layers of paint for more complex and sophisticated effects",
                    "How to paint portraits, still lifes, night scenes, skies, water, and food",
                    "Learn Techniques to create texture, such as using masking fluid, sponges, or other tools to manipulate the paint.",
                    "Learn Improving your composition skills and learning how to design a watercolor painting with focus on balance and movement"],
                color: "#191919",
                image: "/assets/imgs/gallery/w-image3.jpg"
            }
        }
    },
    'graphite-and-charcoal': {
        title: "Graphite and Charcoal",
        synopsis: "",
        levels: {
            basic: {
                price: "$18",
                synopsis: "Foundational techniques for beginners: color mixing and brush control.",
                syllabus: ["Understanding different types of graphite pencils & charcoal (soft, hard, compressed, vine)",
                    "Proper grip & control techniques for smooth strokes",
                    "Shading techniques: hatching, cross-hatching, stippling, and blending",
                    "Creating gradients & tonal values for depth"],
                color: "#2C3333",
                image: "/assets/imgs/gallery/pencil_1.jpeg"
            },
            intermediate: {
                price: "$20",
                synopsis: "Advanced layering and texture work for those with core experience.",
                syllabus: ["Light & shadow: mastering contrast for realistic effects",
                    "Textures: rendering skin, hair, fabric, and natural elements",
                    "Perspective & proportions: drawing accurate figures and objects",
                    "Learn Blending tools: using tortillons, tissue, and fingers effectively"],
                color: "#1A3C40",
                image: "/assets/imgs/gallery/pencil_2.jpeg"
            },
            advanced: {
                price: "$23",
                synopsis: "Professional level coaching focusing on style and complex compositions.",
                syllabus: ["Hyperrealism: refining fine details & capturing lifelike features",
                    "Atmospheric effects: creating mood & depth in drawings",
                    "Mixed media: combining graphite, charcoal, and white chalk",
                    "Learn Developing your artistic style & storytelling through composition"],
                color: "#191919",
                image: "/assets/imgs/gallery/pencil_3.jpeg"
            }
        }
    },
    'pastel-art': {
        title: "Pastel Art",
        synopsis: "",
        levels: {
            basic: {
                price: "$17",
                synopsis: "Fundamentals of using oil pastels, including basic application techniques like layering, blending, mixing, and scumbling",
                syllabus: ["Fundamental techniques like color blending, layering, and creating textures, along with how to choose materials and surfaces suitable for oil pastel art.",
                    "Learn how to apply oil pastels effectively, including using the side of the pastel for broad strokes and the tip for finer details",
                    "Explore different blending techniques, such as using fingers, blending tools, or brushes"],
                color: "#2C3333"
            },
            intermediate: {
                price: "$19",
                synopsis: "Advanced layering and texture work for those with core experience.",
                syllabus: ["In an intermediate oil pastel course, you'll delve deeper into techniques beyond basics, exploring advanced blending methods, creating textures, and mastering color mixing and layering for more complex and expressive artwork",
                    "Pressure Control: Learn to control the pressure of your oil pastel strokes to create a range of effects, from bold, rich colors to subtle, transparent layers.",
                    "Blending Tools: Explore various tools beyond fingers, such as blending stumps, soft brushes, and even specialized oil pastel blending tools."],
                color: "#1A3C40"
            },
            advanced: {
                price: "$22",
                synopsis: "Professional level coaching focusing on style and complex compositions.",
                syllabus: ["In an advanced oil pastel course, you'll learn to create realistic color and blending effects, understand perspective drawing for depth, and master techniques like layering, sgraffito, and mixed media applications to achieve rich, textured surfaces and dynamic artwork",
                    "Realistic Color and Blending:Learn to achieve smooth transitions and gradients, using techniques like blending fingers, or soft cloths.",
                    "Perspective Drawing:Understand how to create a sense of depth and dimension in your artwork through perspective drawing.",
                    "Light Source and Value:Learn to distinguish between highlights, shadows, and midtones to create realistic color transitions and understand how light affects the appearance of objects.",
                    "Layering:Experiment with layering colors to achieve depth and richness in your artwork, starting with lighter colors and gradually moving towards darker ones."],
                color: "#191919"
            }
        }
    },
    'color-pencil': {
        title: "Color pencil",
        synopsis: "",
        levels: {
            basic: {
                price: "$17",
                synopsis: "Foundational techniques for beginners: color mixing and brush control.",
                syllabus: ["Wet and wet and wet and dry technique",
                    "Splattering paint technique",
                    "Dabbing technique",
                    "Learn how to mix paint to achieve the right tones and when to use more opaque or watery color",
                    "Learn how to mix diffrent shades"],
                color: "#2C3333",
                image: "/assets/imgs/gallery/color_p1.jpeg"
            },
            intermediate: {
                price: "$19",
                synopsis: "Advanced layering and texture work for those with core experience.",
                syllabus: ["Wet and wet and wet and dry technique",
                    "Splattering paint technique",
                    "Dabbing technique",
                    "Learn how to mix paint to achieve the right tones and when to use more opaque or watery color",
                    "Learn how to mix diffrent shades"],
                color: "#1A3C40",
                image: "/assets/imgs/gallery/color_p2.jpeg"
            },
            advanced: {
                price: "$22",
                synopsis: "Professional level coaching focusing on style and complex compositions.",
                syllabus: ["Wet and wet and wet and dry technique",
                    "Splattering paint technique",
                    "Dabbing technique",
                    "Learn how to mix paint to achieve the right tones and when to use more opaque or watery color",
                    "Learn how to mix diffrent shades"],
                color: "#191919",
                image: "/assets/imgs/gallery/color_p3.jpeg"
            }
        }
    },
    'acrylic-painting': {
        title: "Acrylic Painting",
        synopsis: "Our Acrylic Painting Course is perfect for anyone who wants to explore the vibrant and versatile world of acrylics. We start with the basics, where you’ll get comfortable with different types of paints, brushes, and surfaces. You’ll learn essential techniques like color mixing, blending, and layering—laying the foundation for your creativity.",
        levels: {
            basic: {
                price: "$20",
                synopsis: "Foundational techniques for beginners: color mixing and brush control.",
                syllabus: [
                    "Types of acrylic paints (student vs. professional grade)",
                    "Understanding brushes, palettes, and surfaces (canvas, wood, paper)",
                    {
                        title: "Setting up a workspace",
                        subItems: [
                            "Primary, secondary, and tertiary colors",
                            "Warm vs. cool colors",
                            "Mixing colors to create different shades"]
                    },
                    "Using palette knives for texture",
                    "Layering and glazing",
                    "Creating depth using perspective"],
                color: "#2C3333",
                image: "/assets/imgs/gallery/acrylic_1.jpeg"
            },
            intermediate: {
                price: "$23",
                synopsis: "Advanced layering and texture work for those with core experience.",
                syllabus: ["Understanding complementary & analogous colors",
                    "Using color to convey mood and emotion",
                    "Creating skin tones and complex hues",
                    "Creating depth with layers",
                    "Smooth blending for realistic effects",
                    "Soft vs. hard edges",
                    "Atmospheric perspective (creating depth in landscapes)",
                    "Rule of thirds and golden ratio",
                    "Detailed landscapes (forests, oceans, sunsets)",
                    "Still life with reflections and transparency (glass, metal)"],
                color: "#1A3C40",
                image: "/assets/imgs/gallery/acrylic_2.jpeg"
            },
            advanced: {
                price: "$25",
                synopsis: "Professional level coaching focusing on style and complex compositions.",
                syllabus: ["Mastering Realism & Hyperrealism:",
                    "Abstract & Expressive Painting:",
                    "Exploring Advanced Textures:",
                    "Light, Shadow & Advanced Perspective:",
                    "Advanced Painting Projects:"],
                color: "#191919",
                image: "/assets/imgs/gallery/acrylic_3.jpeg"
            }
        }
    }
};